var map = {
	"./AdminUserApi.js": 66472,
	"./AdvertisementApi.js": 46555,
	"./AnnouncementApi.js": 50947,
	"./AuditTrailApi.js": 79233,
	"./AuthApi.js": 55264,
	"./BrandApi.js": 18647,
	"./BroadcastApi.js": 22773,
	"./CategoryApi.js": 32242,
	"./CategoryTagApi.js": 99568,
	"./CompanyApi.js": 34349,
	"./ContactUsApi.js": 82492,
	"./ContentManagementApi.js": 442,
	"./CountryApi.js": 96326,
	"./CouponApi.js": 76116,
	"./CustomerApi.js": 68370,
	"./DashboardApi.js": 54176,
	"./EmailBlastApi.js": 97008,
	"./GoogleAuthenticatorApi.js": 49878,
	"./LaboratoryApi.js": 70253,
	"./LaboratoryOperationApi.js": 38970,
	"./LocaleApi.js": 31896,
	"./NationalityApi.js": 78434,
	"./OurCustomerApi.js": 92498,
	"./PackageApi.js": 7396,
	"./PackageTranslationApi.js": 28179,
	"./ProductApi.js": 71229,
	"./ProductTranslationApi.js": 61784,
	"./QuotationApi.js": 53886,
	"./ReferenceDataApi.js": 15683,
	"./ReferralCodeApi.js": 42038,
	"./ShippingRateApi.js": 74650,
	"./StateApi.js": 97431,
	"./SupportiveApi.js": 71447,
	"./SystemCurrencyApi.js": 11196,
	"./SystemVariableApi.js": 81841,
	"./TaxApi.js": 45183,
	"./UserAddressApi.js": 7363,
	"./UserApi.js": 19315,
	"./UserAssetBalanceListApi.js": 76143,
	"./UserAssetHistoryApi.js": 73851,
	"./VendorApi.js": 46596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38292;